import './App.css';
import './components/styles/general.css'
import './components/FontawesomeIcons'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginForm            from './pages/login/Login';
import SuperSignupForm            from './pages/SuperLogin/SuperSignup';
import Dashboard            from './pages/Dashboard/Dashboad';
import SideNavBar           from './components/SideNavBar';
import SupervisorsPage      from './pages/Supervisors/Supervisors';
import PostsPage            from './pages/Posts/PostsPage';
import PostsPendingPage     from './pages/PostsPending/PostsPendingPage';
import ArtilcesPage         from './pages/Articles/ArticlesPage';
import SingleArticlesPage   from './pages/Articles/SingleArticle';
import PatientProfile       from './pages/Profiles/PatientProfile';
import DoctorProfile        from './pages/Profiles/DoctorProfile';
import TestChatPage         from './pages/test/TestChat';
import TestNotifyPage       from './pages/test/TestNotify';
import TestPayment from './pages/test/TestPayment';
import AI_Chat from './components/AI_Chat';
import Firebaselogin from './pages/test/Flogin';
import UnverifiedDoctors from './pages/Doctors/UnverifiedDoctors';
import VerifiedDoctors from './pages/Doctors/VerifiedDoctors';
import DoctorInfo from './pages/Doctors/DoctorInfo';
import AppointmentsPage from './pages/Appointments/AppointmentsPage';
import SettingsPage from './pages/Settings/SettingsPage';
import SendNotifications from './pages/Notifications/SendNotifications';
import CreatePostPage from './pages/CreatePost/CreatePostPage';
import CreateArticlePage from './pages/CreateArticle/CreateArticlePage';
import CommunitiesPage from './pages/Communities/CommunitiesPage';
import ProtectedRoute from './components/ProtectedRoute';
import VoucherPage from './pages/Voucher/VoucherPage';
import VoucherDetailsPage from './pages/Voucher/VoucherDetailsPage';
import AddVoucherPage from './pages/Voucher/AddVoucherPage';
import EditVoucherPage from './pages/Voucher/EditVoucherPage';
import AdminQAPage from './pages/QA/AdminQAPage';
import FadfaddahPage from './pages/Fadfaddah/FadfaddahPage';
import PaymentsPage from './pages/Payments/PaymentsPage';
function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path='/Login' element={<LoginForm/>} />
          <Route path='/supersignup/:token' element={<SuperSignupForm/>} />
          <Route path='/*' element={
                    <ProtectedRoute>
                      <SideNavBar />
                      <Routes>
                          <Route path='/' element={<Navigate to="/dashboard"/>} />
                          <Route path='dashboard' element={<Dashboard/>} />
                          <Route path='supervisors' element={
                            // <ProtectedRoute requiredRole="admin">
                              <SupervisorsPage/>
                            // </ProtectedRoute>
                          } />
                          <Route path='doctors/unverified' element={
                            <ProtectedRoute requiredRole="super">

                              <UnverifiedDoctors/>
                              </ProtectedRoute>
                          } />
                          <Route path='doctors/verified' element={
                            <ProtectedRoute requiredRole="super">
                              <VerifiedDoctors/>
                              </ProtectedRoute>
                          } />
                          <Route path='doctors/info/:doctorID' element={
                            <ProtectedRoute requiredRole="super">
                              <DoctorInfo/>
                             </ProtectedRoute>
                          } />
                          <Route path='appointments' element={
                            <ProtectedRoute requiredRole="super">
                              <AppointmentsPage/>
                            </ProtectedRoute>
                          } />
                          <Route path='payments' element={
                            <ProtectedRoute requiredRole="super">
                              <PaymentsPage/>
                            </ProtectedRoute>
                          } />
                          <Route path='posts' element={<PostsPage/>} />
                          <Route path='posts-pending' element={<PostsPendingPage/>} />
                          <Route path='posts/create' element={<CreatePostPage/>} />
                          <Route path='articles' element={<ArtilcesPage/>} />
                          <Route path='articles/create' element={<CreateArticlePage/>} />
                          <Route path='articles/:articleID' element={<SingleArticlesPage/>} />
                          <Route path='communities' element={<CommunitiesPage/>} />
                          <Route path='voucher' element={<VoucherPage/>} />
                          <Route path='voucher/:voucherId' element={<VoucherDetailsPage/>} />
                          <Route path='voucher/new' element={<AddVoucherPage/>} />
                          <Route path='voucher/:voucherId/edit' element={<EditVoucherPage/>} />
                          <Route path='qa' element={<AdminQAPage/>} />
                          <Route path='chats' element={<FadfaddahPage/>} />
                          <Route path='notifications' element={<SendNotifications/>} />
                          <Route path='settings' element={
                            <ProtectedRoute requiredRole="super">
                              <SettingsPage/>
                            </ProtectedRoute>
                          } />
                          <Route path='profile/patient/:patientID' element={<PatientProfile/>} />
                          <Route path='profile/doctor/:doctorID' element={<DoctorProfile/>} />
                          <Route path='test' element={<TestChatPage/>} />
                          <Route path='testnotify' element={<TestNotifyPage/>} />
                          <Route path='testPay' element={<TestPayment/>} />
                          <Route path='testlogin' element={<Firebaselogin/>} />
                      </Routes>
                      {/* <AI_Chat/> */}
                    </ProtectedRoute>
          } />
        </Routes>
      </Router>

    </div>
  );
}

export default App;
